class Components {

	constructor(com) {
		if (this[com.getAttribute('data-ess-component')]) {
			this[com.getAttribute('data-ess-component')](this, com);
		}
	}

	//	Range slider
	componentFilter(com, el) {
		Promise.all([
			import ( /* webpackChunkName: "forms" */ 'ion-rangeslider'),
		]).then(([ionRangeSlider]) => {
			$('input[data-provide="slider"]').ionRangeSlider({
			});

			live('click', '.trigger-facets-groups', () => {
				document.querySelector('.facets-groups').classList.toggle('show-filters');
				document.querySelector('html').classList.toggle('overlay', document.querySelector('.facets-groups').classList.contains('show-filters'));
			});
			live('click', '.trigger-filter-close', () => {
				document.querySelector('.facets-groups').classList.remove('show-filters');
				document.querySelector('html').classList.remove('overlay');
			});

			enquire.register('screen and (min-width:768px)', {
				match: function () {
					if (document.querySelector('.facets-groups') && document.querySelector('.facets-groups').classList.contains('show-filters')) {
						document.querySelector('.facets-groups').classList.remove('show-filters');
						document.querySelector('html').classList.remove('overlay');
					}
				}
			});
		});
	}

	//	Datepicker
	componentDatepicker(com, el) {
		require('flatpickr');
		const Slovenian = require("flatpickr/dist/l10n/sl").default.sl;

		flatpickr(el, {
			dateFormat: 'd.m.Y',
			locale: Slovenian,
			time_24hr: true,
			// minDate: new Date()
		})
	}

	//	Date range picker
	componentDateRangepicker(com, el) {
		require('flatpickr');
		const Slovenian = require("flatpickr/dist/l10n/sl").default.sl;

		flatpickr(el, {
			dateFormat: 'd.m.Y',
			mode: 'range',
			locale: Slovenian,
			time_24hr: true,
			// minDate: new Date()
		})
	}

	componentQuicksearch(com, el) {
		let quickSearchShown = false;
		el.querySelector('.trigger-search').addEventListener('click', function (e) {
			e.preventDefault();
			quickSearchShown = true;
			el.classList.toggle('is-shown', quickSearchShown);
		});

		document.querySelector('.trigger-search-close').addEventListener('click', function (e) {
			e.preventDefault();
			quickSearchShown = false;
			el.classList.toggle('is-shown', quickSearchShown);
		})
	}

	componentMobileUserLoggedIn(com, el) {
		let userNavigationShown = false;
		el.querySelector('.trigger-user').addEventListener('click', function (e) {
			e.preventDefault();
			userNavigationShown = true;
			el.classList.toggle('is-shown', userNavigationShown);
		});

		document.querySelector('.trigger-user-close').addEventListener('click', function (e) {
			e.preventDefault();
			userNavigationShown = false;
			el.classList.toggle('is-shown', userNavigationShown);
		})
	}

	// Accordion
	componentAccordion(com, el) {
		let handorgel = require('handorgel');
		let accordion = new handorgel.default(el, {

			// whether multiple folds can be opened at once
			multiSelectable: false,
			// whether the folds are collapsible
			collapsible: true,

			// whether ARIA attributes are enabled
			ariaEnabled: true,
			// whether W3C keyboard shortcuts are enabled
			keyboardInteraction: true,
			// whether to loop header focus (sets focus back to first/last header when end/start reached)
			carouselFocus: true,

			// attribute for the header or content to open folds at initialization
			initialOpenAttribute: 'data-open',
			// whether to use transition at initial open
			initialOpenTransition: false,
			// delay used to show initial transition
			initialOpenTransitionDelay: 200,
		});
	}

	// Work competences treeview. Glej: https://github.com/aexmachina/jquery-bonsai
	componentCompetences(com, el) {
		const bonsai = require('jquery-bonsai/jquery.bonsai.js');

		const treelist = $('#' + el.id).bonsai({
			expandAll: false,
			checkboxes: true, // depends on jquery.qubit plugin
			createInputs: 'checkbox' // takes values from data-name and data-value, and data-name is inherited
		});

		// Izbrane vrednosti se vpišejo v input[type=hidden], ki je določen na wrapperju pod data-input z imenom
		live('change', '.bonsai input[type=checkbox]', () => {
			var treeselected = [];
			$('.bonsai input:checkbox').each(function (i, v) {
				if ($(this).is(':checked') || $(this).is(':indeterminate')) {
					treeselected.push($(this).val());
				}
			})
			document.querySelector('input[name="' + el.dataset.input + '"]').value = treeselected.join(',');
		})

	}

	componentMultiSwitch(com, el) {
		let multiswitch = require('./components/multi-switch');
		$(el.querySelector('.multi-switch')).multiSwitch();
	}

	componentMultiCheckbox(com, el) {
		$(el).addClass('has-children');
		$(el).find('.collapse input.custom-control-input').each(function() {
			$(this).addClass('child');
		})
		$(el).find('input.custom-control-input').first().addClass('parent');
		$(el).find('#expand').bind('click', function () {
			var header = $(this);
	    var content = $(el).find('.collapse');
	    content.slideToggle(300, function () {
	        header.html(function () {
	            return content.is(':visible') ? '<svg class="ticon"><use xlink:href="/media/dsg/icons.svg?#icon-minus"></use></svg>' : '<svg class="ticon"><use xlink:href="/media/dsg/icons.svg?#icon-plus"></use></svg>';
	        });
	    });
			return false;
		});
		$(el).find('input.parent').bind('click', function () {
			$(this).parent().find('input.child').prop('checked', this.checked);
		});
		$(el).find('.collapse input.child').bind('click', function () {
			var parent = $(el).find('input.parent');
			if (parent.prop('checked') == true && this.checked == false){
				parent.prop('checked', false);
			}
			if (this.checked == true){
				var flag = true;
				var child = $(this).closest('.collapse').find('input.child').each(
					function() {
						if (this.checked == false)
							flag = false;
					}
				);
				parent.prop('checked', flag);
			}
		});
	}
}

Array.prototype.slice.call(document.querySelectorAll('*[data-ess-component^="component"]')).forEach((value, index) => {
	new Components(value);
});
